<template>
    <v-app id="bqual">
        <v-alert prominent :value="hasMessage" :type="getType" class="alert-bar" transition="scale-transition">
            <v-row align="center">
                <v-col class="grow">{{alert.message}}</v-col>
                <v-col class="shrink">
                    <v-icon v-if="alert.message" @click="closeAlert()">mdi-window-close</v-icon>
                </v-col>
            </v-row>
        </v-alert>
        <v-navigation-drawer v-if="loggedIn" v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <div class="fill-height d-flex flex-column justify-space-between">
                <Menu />

                <div class="nav-version">
                    Version: {{ versionNumber }}
                </div>
            </div>
        </v-navigation-drawer>
        <v-app-bar v-if="loggedIn" :clipped-left="$vuetify.breakpoint.lgAndUp" app color="secondary">
            <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
                <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            </v-toolbar-title>
            <v-spacer />

            <v-menu open-on-hover>
                <template v-slot:activator="{ on }">
                    <v-btn icon large v-on="on"><v-avatar tile><v-icon>mdi-account</v-icon></v-avatar></v-btn>
                </template>

                <v-list>
                    <v-list-item @click="logout">
                        <v-list-item-title>Log out</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="changePassword">
                        <v-list-item-title>Change Password</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-content v-if="showContent" :class="(loggedIn ? null : 'pa-0')">
            <router-view />
        </v-content>
    </v-app>
</template>

<script>
    import axios from 'axios'
    import { mapState } from 'vuex'

    export default {
        components: {
            Menu: () => import('./components/Menu')
        },

        data() {
            return {
                drawer: null,
                versionNumber: null,
                isLoaded: false
            }
        },

        async mounted() {
            await this.loadGoogleMapsScript();
            this.$store.dispatch('authentication/initialize');
            this.getVersion();
        },

        methods: {
            async getVersion() {
                var response = await axios.get('/api/Version');
                this.versionNumber = response.data.versionNumber;
            },

            logout() {
                this.$store.dispatch('authentication/logout')
            },

            changePassword() {
                this.$router.push({ path: '/change-password' });
            },

            closeAlert() {
                this.$store.dispatch('alert/clear');
            },

            async loadGoogleMapsScript() {
                if (window.google || document.getElementById('googleMapsScript')) {
                    this.isLoaded = true;
                    return;
                }
                const response = await axios.get('/api/GoogleMaps/ApiKey');
                const apiKey = response.data;
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&v=weekly`;
                script.async = true;
                script.onload = () => {
                    this.isLoaded = true;
                };
                document.head.appendChild(script);
            }
        },

        computed: {
            ...mapState({
                status: s => s.authentication.status,
                user: s => s.authentication.user,
                alert: s => s.alert
            }),
            loggedIn() {
                return this.$store.state.authentication.status.loggedIn;
            },
            showContent() {
                var alwaysAvailablePaths = [
                    '/login',
                    '/reset-password',
                    '/request-reset-password',
                    '/new-user-set-password'
                ];

                return !!this.user && this.isLoaded || alwaysAvailablePaths.indexOf(this.$route.path) > -1;
            },
            getType() {
                return (this.alert.type && this.alert.type === 'alert-success') ? "success" : "error";
            },
            hasMessage() {
                if (this.alert.message) {
                    return true;
                }
                return false;
            },
        },

        watch: {
            $route(to) {
                // clear alert on location change
                this.$store.dispatch('alert/clear');

                var title = to.name.replace(/([A-Z])/g, " $1");
                var finalTitle = title.charAt(0).toUpperCase() + title.slice(1);
                document.title = finalTitle + ' - B-QUAL' || 'B-QUAL'
            }
        }
    }
</script>

<style>
    #bqual .nav-version {
        padding: 20px 40px;
        text-align: center;
    }

    #bqual .v-data-table-header {
        white-space: nowrap;
    }

    #bqual .alert-bar {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        z-index: 9999;
    }
</style>
